//TODO: Should we support all of these? Taken from MB3
export const whoisCountriesToLocales_ALL: { [key: string]: string | string[] } = {
  // English
  'AE': 'en-GB', // United Arab Emirates
  'BG': 'en-GB', // Bulgaria
  'CZ': 'en-GB', // Czech Republic
  'DK': 'en-GB', // Denmark
  'EE': 'en-GB', // Estonia
  'FI': 'en-GB', // Finland
  'GB': 'en-GB', // United Kingdom
  'GR': 'en-GB', // Greece
  'HR': 'en-GB', // Croatia
  'HU': 'en-GB', // Hungary
  'IE': 'en-IE', // Ireland
  'IL': 'en-GB', // Israel
  'LT': 'en-GB', // Lithuania
  'LV': 'en-GB', // Latvia
  'MT': 'en-MT', // Malta
  'NL': 'en-GB', // Netherlands
  'NO': 'en-GB', // Norway
  'PL': 'en-GB', // Poland
  'PT': 'en-GB', // Portugal
  'RO': 'en-GB', // Romania
  'SA': 'en-GB', // Saudi Arabia
  'SE': 'en-GB', // Sweden
  'SI': 'en-GB', // Slovenia
  'SK': 'en-GB', // Slovakia
  // French
  'FR': 'fr-FR', // France
  'MC': 'fr-MC', // Monaco
  // German
  'AT': 'de-AT', // Austria
  'DE': 'de-DE', // Germany
  // Italian
  'IT': 'it-IT', // Italy
  'SM': 'it-IT', // San Marino
  // Spanish
  'ES': 'es-ES', // Spain
  // Multiple
  'BE': ['fr-BE', 'de-BE', 'en-BE'], // Belgium
  'CA': ['en-CA', 'fr-CA'], // Canada
  'CH': ['de-CH', 'fr-CH', 'it-CH', 'en-GB'], // Switzerland
  'LU': ['fr-LU', 'de-LU', 'en-GB'], // Luxembourg
  'US': ['en-US', 'es-US'], // United States
};

export const whoisCountriesToLocales: { [key: string]: string | string[] } = {
  'US': ['en-US'], // United States
}

export const supportedLocales = [
  ...new Set(Object.values(whoisCountriesToLocales).flatMap((locale) => locale)),
];
